




































































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import allTrain from "@/views/train/allTrain.vue";
import myTrain from "@/views/train/myTrain.vue";
import searchInput from "@/components/searchInput.vue";
import util from "@/lib/util";
import ShortHeaderLayout from "@/layouts/shortHeaderLayout.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import DescriptionList from "@/components/DescriptionList/DescriptionList.vue";
import DescriptionListItem from "@/components/DescriptionList/DescriptionListItem.vue";
import _ from "lodash";
import Util from "@/lib/util";
import AppConsts from "@/lib/appconst";

@Component({
  components: {
    DescriptionListItem,
    DescriptionList,
    ShortHeaderLayout,
    basicPage,
    allTrain,
    myTrain,
    searchInput
  },
  filters: {
    imgUrlFilter(url: string) {
      if (url && url.indexOf('http') > -1) {
        return url;
      } else if (url) {
        let fileResourceUrl: string = AppConsts.fileResourceUrl;
        return `${fileResourceUrl}${url}`;
      } else {
        return '/img/icons/avatar_def_icon.png';
      }
    }
  }
})
export default class userOverview extends basicPage {
  customActiveKey = '0'
  hasHeight: boolean = false;
  data: any = {};
  resourcesPath: string = '';
  form: any;

  uploadConfig = {
    multiple: false,
    url: AppConsts.remoteServiceBaseUrl + '/web/resources/upload2',
    fileList: [],
    headers: {
      'X-SoilInfo-Token': window.abp.auth.getToken()
    },
    beforeUpload: (file) => {
      // this.uploadConfig.fileList = [];
      this.uploadConfig.fileList = [file];
      return true;
    }
  }


  handleUpload(info) {
    if (info.file.status !== "uploading") {
    }
    if (info.file.status === "done") {
      if (info.file.response.errno == 0) {
        let rep = info.file.response.data;
        // this.uploadConfig.fileList.push(info.file)
        this.resourcesPath = rep.resourcesPath;
      } else {
        this.$message.error("文件上传失败");
      }
    } else if (info.file.status === "error") {
      this.$message.error(`${info.file.name} file upload failed.`);
    }
  }

  loadData() {
    ajaxHelperInstance.get('web/auth/info').then((res) => {
      let {data, errno, message} = res.data;
      if (errno != 0) {
        return
      }
      this.data = data;
      if (this.data.avatar) {
        this.data.avatar = this.data.avatar;
      }

      util.setFormValue(this.form, data);
      console.log(data);
    })
  }

  getAvatorUrl(url) {
    if (url) {
      url = AppConsts.fileResourceUrl + url;
    }
    return url;
  }


  changeUserInfo() {
    this.$router.push({
      name: 'userinfo',
    })
  }

  mounted() {
    this.loadData();
  }

  beforeCreate() {
    this.form = this.$form.createForm(this);
  }

  handleSubmit(e) {
    let self = this;
    e.preventDefault();
    this.form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      let reqData = values;
      reqData.realName = reqData.nickName;
      reqData.avatarUrl = self.resourcesPath;

      ajaxHelperInstance.postM('/web/user/changeAvatar', reqData).then((res) => {
        let {data, errno, message} = res.data;
        if (errno != 0) {
          this.$message.info(message);
          return;
        }
        self.loadData();
        self.$store.commit("session/setUserAvator", {
          avatar: data.avatarUrl, nickname: reqData.nickName
        });
        this.uploadConfig.fileList = [];
        this.$message.success("保存成功!");
      })

    });
  }

}
